// extracted by mini-css-extract-plugin
module.exports = {"reviewReviewsChart":"ReviewReviewsChart_reviewReviewsChart__2s3TQ","reviewReviewsChart__chart":"ReviewReviewsChart_reviewReviewsChart__chart__3pAtW"};